<template>
    <svg width="11.939209px" height="20.878998px" viewBox="0 0 11.939209 20.878998" version="1.1" xmlns:xlink="http://www.w3.org/1999/xlink" xmlns="http://www.w3.org/2000/svg">
        <g id="iconChevronRight" transform="translate(-11.560547 -5.560501)">
            <path d="M12 26L12 26C11.414 25.414 11.414 24.465 12 23.879L19.879 16L12 8.121C11.414 7.535 11.414 6.586 12 6C12.586 5.414 13.535 5.414 14.121 6L23.061 14.939C23.646 15.525 23.646 16.475 23.061 17.061L14.121 26C13.535 26.586 12.586 26.586 12 26" id="ChevronRight" fill-rule="evenodd" stroke="none" />
        </g>
    </svg>
</template>